import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import sales from "../../../Data/sales.json";
import customers from "../../../Data/customers.json";
import toast from "react-hot-toast";
import { get_all_invoices } from "../../../Controllers/Sales/Invoices";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import {
  get_net_sales_reports,
  get_sales_reports,
} from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";


const NetSalesReport = () => {
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const componentRef = useRef(null); 

  const headers = {
    name: "Net Sales",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: 0, label: "Price (Low-High)" },
          { value: 1, label: "Price (High-Low)" },
        ],
      },
      {
        type: "filter",
        name: "customer",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Customer",
        api: "get-all-customers",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: 0, label: "Inactive" },
          { value: 1, label: "Active" },
        ],
      },
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
      {
        type: "range",
        name: "due_date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        customer: tabledata?.customer,
        branch: tabledata?.branch,
        status: tabledata?.status,
        date: tabledata?.date,
        due_date: tabledata?.due_date,
      };

      const products = await get_net_sales_reports(data);
      if (products?.status) {
        setBody(products?.data);
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div className="text-right pb-4">
          <ReactToPrint
            trigger={() => (
              <Button
                className="bg-white border rounded hover:border-green-500 w-36"
                type="button"
                size="large"
              >
                Print <PrinterOutlined className="text-lg" />
              </Button>
            )}
            content={() => componentRef.current}
            pageStyle={`
              @page {
                size: landscape;
                margin: 20mm;
              }
                table {
                border-collapse: collapse;
                width: 100%;
              }
              th, td {
                border: 1px solid #ddd;
                padding: 6px;
              }
              th {
                background-color: #f4f4f4;
              }
            `}
          />
        </div>
        <div ref={componentRef}>
        <table className="w-full bg-white border-collapse">
          <thead className="text-gray-500 bg-gray-100">
            <tr>
              <th className="border p-2 text-sm font-normal text-left">
                Invoice
              </th>
              <th className="border p-2 text-sm font-normal">Customer</th>
              <th className="border p-2 text-sm font-normal">Branch</th>
              <th className="border p-2 text-sm font-normal">Date</th>
              <th className="border p-2 text-sm font-normal">Subtotal</th>
              <th className="border p-2 text-sm font-normal">Discount</th>
              <th className="border p-2 text-sm font-normal">Tax [VAT]</th>
              <th className="border p-2 text-sm font-normal">
                Delivery Charge
              </th>
              <th className="border p-2 text-sm font-normal">Total</th>
              <th className="border p-2 text-sm font-normal text-right">
                Net Profit
              </th>
            </tr>
          </thead>
          <tbody className="">
            {body?.map((value, index) => (
              <React.Fragment key={index}>
                <tr className="bg-white ">
                  <td className="border p-2 text-sm text-medium text-left">
                    #INV {value?.number}
                  </td>
                  <td className="border p-2 text-sm text-medium text-center">
                    {value?.customer?.name}
                  </td>
                  <td className="border p-2 text-sm text-medium text-center">
                    {value?.branch?.name}
                  </td>
                  <td className="border p-2 text-sm text-medium text-center">
                    {value?.date
                      ? moment(value?.date).format("DD-MM-YYYY")
                      : ""}
                  </td>
                  <td className="border p-2 text-sm text-medium text-center">
                    {value?.subtotal?.toFixed?.(3)}
                  </td>
                  <td className="border p-2 text-sm text-medium text-center">
                    {value?.discount?.toFixed?.(3)}
                  </td>
                  <td className="border p-2 text-sm text-medium text-center">
                    {value?.taxamount?.toFixed?.(3)}
                  </td>
                  <td className="border p-2 text-sm text-medium text-center">
                    {value?.delivery?.toFixed?.(3)}
                  </td>
                  <td className="border p-2 text-sm text-medium text-center">
                    {value?.total?.toFixed?.(3)}
                  </td>
                  <td className="border p-2 text-sm text-medium text-right">
                    {value?.grand_total_net_profit?.toFixed?.(3)}
                  </td>
                </tr>
                {/* Details Row */}
                <tr>
                  <td colSpan={10} className="p-2">
                    <table className="w-full border text-gray-500 bg-gray-50">
                      <thead>
                        <tr className=" font-normal">
                          <th className="border p-1 text-xs font-normal">
                            S.NO
                          </th>
                          <th className="border p-1 text-xs font-normal">
                            DESCRIPTION
                          </th>
                          <th className="border p-1 text-xs font-normal">
                            UNIT
                          </th>
                          <th className="border p-1 text-xs font-normal">
                            QTY
                          </th>
                          <th className="border p-1 text-xs font-normal">
                            RET.PRICE
                          </th>
                          <th className="border p-1 text-xs font-normal">
                            W.S PRICE
                          </th>
                          <th className="border p-1 text-xs font-normal">
                            DISC
                          </th>
                          <th className="border p-1 text-xs font-normal">
                            FOC
                          </th>
                          <th className="border p-1 text-xs font-normal">
                            VAT
                          </th>
                          <th className="border p-1 text-xs font-normal">
                            TOTAL
                          </th>
                          <th className="border p-1 text-xs font-normal">
                            NET.PROFIT
                          </th>
                        </tr>
                      </thead>
                      <tbody className="text-gray-500">
                        {value?.details?.map((v, i) => (
                          <tr key={i} className="text-xs">
                            <td className="border p-1 text-center">
                              <div>{i + 1}</div>
                            </td>
                            <td className="border p-1 text-center">
                              <div>
                                <div>{v?.name}</div>
                                <div className="text-gray-500 text-xs">
                                  #BATCH-{v?.description?.number}
                                </div>
                                {v?.expiry_date && (
                                  <div className="text-gray-500 text-xs">
                                    Expiry:{" "}
                                    {moment(v?.expiry_date).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </div>
                                )}
                              </div>
                            </td>
                            <td className="border p-1 text-center">
                              {v?.unit_name}
                            </td>
                            <td className="border p-1 text-center">
                              {v?.quantity}
                            </td>
                            <td className="border p-1 text-center">
                              {v?.description?.sale_price?.toFixed?.(3)}
                            </td>
                            <td className="border p-1 text-center">
                              {v?.sale_price?.toFixed?.(3)}
                            </td>
                            <td className="border p-1 text-center">
                              <div>{v?.discount_percentage}%</div>
                              <div className="text-xs text-gray-500">
                                {v?.discount_price?.toFixed?.(3)}
                              </div>
                            </td>
                            <td className="border p-1 text-center">
                              {v?.free || 0}
                            </td>
                            <td className="border p-1 text-center">
                              <div>{v?.tax}%</div>
                              <div className="text-xs text-gray-500">
                                {v?.tax_amount?.toFixed?.(3)}
                              </div>
                            </td>
                            <td className="border p-1 text-center">
                              {v?.total?.toFixed?.(3)}
                            </td>
                            <td className="border p-1 text-center">
                              {v?.total_net_profit?.toFixed?.(3)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>
                </tr>
              </React.Fragment>
            ))}
            {/* Totals Row */}
            <tr className="font-semibold bg-gray-100 text-sm">
              <td className="border p-2 font-normal text-medium" colSpan={4}>
                Total
              </td>
              <td className="border p-2 font-normal text-medium">
                {body
                  ?.reduce((acc, val) => acc + (val?.subtotal || 0), 0)
                  ?.toFixed?.(3)}
              </td>
              <td className="border p-2 font-normal text-medium">
                {body
                  ?.reduce((acc, val) => acc + (val?.discount || 0), 0)
                  ?.toFixed?.(3)}
              </td>
              <td className="border p-2 font-normal text-medium">
                {body
                  ?.reduce((acc, val) => acc + (val?.taxamount || 0), 0)
                  ?.toFixed?.(3)}
              </td>
              <td className="border p-2 font-normal text-medium">
                {body
                  ?.reduce((acc, val) => acc + (val?.delivery || 0), 0)
                  ?.toFixed?.(3)}
              </td>
              <td className="border p-2 font-normal text-medium">
                {body
                  ?.reduce((acc, val) => acc + (val?.total || 0), 0)
                  ?.toFixed?.(3)}
              </td>
              <td className="border p-2 font-normal text-right text-medium">
                {body
                  ?.reduce(
                    (acc, val) => acc + (val?.grand_total_net_profit || 0),
                    0
                  )
                  ?.toFixed?.(3)}
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </Loadercomponent>
    </Header>
  );
};

export default NetSalesReport;
